// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.report-detail {
  color: #1f2937;
  background: #f1f5f9;
  border-radius: 0;
  overflow: hidden;
  min-height: 100%;
}
.report-detail__toolbar {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}
.report-detail__stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

.report-panel {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  overflow: hidden;
}
.report-panel--updates:has(> eview-post-updates.post-updates-host--hidden) {
  display: none;
}
.report-panel__head {
  padding: 14px 20px 0;
}
.report-panel__head--editable {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.report-panel__edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.report-panel__edit-btn:hover {
  background: #eef2f7;
  color: var(--undp-jtf-btn-dark-color, #003d7a);
}
.report-panel__edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);
}
.report-panel__title {
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eef2f7;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  flex: 1 1 auto;
}
.report-panel__body {
  padding: 16px 20px 20px;
}
.report-panel__body--flush {
  padding: 0;
}
.report-panel--analysis .report-analysis__input {
  width: 100%;
  min-height: 140px;
  resize: vertical;
  line-height: 1.55;
}
.report-panel--analysis .report-analysis__readonly {
  margin: 0 0 14px;
  white-space: pre-wrap;
  color: #1f2937;
  font-size: 15px;
  line-height: 1.65;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  min-height: 80px;
}
.report-panel--analysis .report-analysis__actions {
  margin-bottom: 14px;
}
.report-panel--analysis .report-analysis__file {
  margin-top: 14px;
}
.report-panel--analysis .report-analysis__file--readonly {
  margin-top: 12px;
}
.report-panel--analysis .report-analysis__file-empty-text {
  margin: 8px 0 0;
  color: #94a3b8;
  font-size: 13px;
}
.report-panel--analysis .report-analysis__file-error {
  margin: 8px 0 0;
  font-size: 13px;
}
.report-panel--analysis .analysis-file-dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 112px;
  margin: 0;
  padding: 18px 16px;
  cursor: pointer;
  text-align: center;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1.5px dashed #cbd5e1;
  border-radius: 10px;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.report-panel--analysis .analysis-file-dropzone:hover:not(.analysis-file-dropzone--disabled) {
  border-color: #64748b;
  background: #f8fafc;
  box-shadow: inset 0 0 0 1px rgba(100, 116, 139, 0.08);
}
.report-panel--analysis .analysis-file-dropzone--disabled, .report-panel--analysis .analysis-file-dropzone--uploading {
  cursor: default;
  opacity: 0.85;
  pointer-events: none;
}
.report-panel--analysis .analysis-file-dropzone__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  padding: 4px 8px;
  border-radius: 6px;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
}
.report-panel--analysis .analysis-file-dropzone__title {
  font-size: 14px;
  color: #1e293b;
}
.report-panel--analysis .analysis-file-dropzone__hint {
  max-width: 280px;
  font-size: 12px;
  line-height: 1.4;
  color: #94a3b8;
}
.report-panel--analysis .analysis-file-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.report-panel--analysis .analysis-file-card--readonly {
  width: 100%;
  margin: 0;
  cursor: pointer;
  text-align: left;
}
.report-panel--analysis .analysis-file-card--readonly:hover {
  background: #f1f5f9;
  border-color: #dbe3ee;
}
.report-panel--analysis .analysis-file-card--readonly:hover .analysis-file-card__name {
  color: #1d4ed8;
}
.report-panel--analysis .analysis-file-card--uploading {
  opacity: 0.75;
}
.report-panel--analysis .analysis-file-card__main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1 200px;
}
.report-panel--analysis .analysis-file-card__badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  padding: 6px 8px;
  border-radius: 6px;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
}
.report-panel--analysis .analysis-file-card__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.report-panel--analysis .analysis-file-card__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0f172a;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  max-width: 100%;
}
.report-panel--analysis .analysis-file-card__name:hover {
  color: #1d4ed8;
}
.report-panel--analysis .analysis-file-card__name--btn {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.report-panel--analysis .analysis-file-card__name--pending {
  color: #64748b;
  font-weight: 500;
}
.report-panel--analysis .analysis-file-card__sub {
  font-size: 12px;
  color: #94a3b8;
}
.report-panel--analysis .analysis-file-card__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.report-panel--analysis .analysis-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}
.report-panel--analysis .analysis-icon-btn:hover:not(:disabled):not(.is-disabled) {
  background: #eef2f7;
  color: #0f172a;
}
.report-panel--analysis .analysis-icon-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);
}
.report-panel--analysis .analysis-icon-btn:disabled, .report-panel--analysis .analysis-icon-btn.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.report-panel--analysis .analysis-icon-btn--danger {
  color: #94a3b8;
}
.report-panel--analysis .analysis-icon-btn--danger:hover:not(:disabled):not(.is-disabled) {
  background: #fef2f2;
  color: #b91c1c;
}
.report-panel--analysis .analysis-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  padding: 8px 14px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}
.report-panel--analysis .analysis-btn:hover:not(:disabled):not(.is-disabled) {
  background: #f1f5f9;
  color: #0f172a;
}
.report-panel--analysis .analysis-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18);
}
.report-panel--analysis .analysis-btn:disabled, .report-panel--analysis .analysis-btn.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
}
.report-panel--analysis .analysis-btn--ghost {
  background: transparent;
  border-color: #d0d7de;
  color: #5c6b7a;
}
.report-panel--analysis .analysis-btn--ghost:hover:not(:disabled):not(.is-disabled) {
  background: transparent;
  border-color: #b8c2cc;
  color: #334155;
}
.report-panel--analysis .analysis-btn--primary {
  background: var(--undp-jtf-btn-dark-color, #003d7a);
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 61, 122, 0.16);
}
.report-panel--analysis .analysis-btn--primary:hover:not(:disabled):not(.is-disabled) {
  background: var(--undp-jtf-btn-dark-color, #003d7a);
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: #fff;
  opacity: 0.92;
}
.report-panel--analysis .analysis-btn--primary:focus {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--undp-jtf-primary-color, #2563eb) 28%, transparent);
}
.report-panel--analysis .report-analysis__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
}

.active-card-item {
  border-top: none;
  box-shadow: none;
}

.word-wrap {
  word-break: break-word;
  line-height: 1.6;
  color: #1f2937;
}

.custom-ui {
  color: var(--undp-jtf-text-color);
}
.custom-ui .modal-body {
  padding: 32px;
  border-radius: 8px;
}
.custom-ui .modal-body p {
  font-size: 16px;
  margin-bottom: 24px;
  color: #374151;
  line-height: 1.6;
}
.custom-ui .modal-body .btn {
  border-radius: 8px;
  padding: 12px 28px;
  font-weight: 600;
}

::ng-deep .report-detail .card-subtitle,
::ng-deep .report-detail .flex-subtitle-wrapper {
  margin: 0 !important;
  padding: 16px 20px !important;
  background: transparent !important;
  border: none !important;
}
::ng-deep .report-detail eview-post-map-view {
  display: block;
}

/* Same shell as form-attribute media confirm preview */
::ng-deep .media-upload-confirm-modal {
  z-index: 1070 !important;
}
::ng-deep .media-upload-confirm-modal .modal-dialog {
  max-width: min(100vw - 1.25rem, 780px);
  margin: 0.75rem auto;
  max-height: calc(100vh - 1.5rem);
}
::ng-deep .media-upload-confirm-modal .modal-content {
  border-radius: 10px;
  border: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  max-height: calc(100vh - 1.5rem);
  display: flex;
  flex-direction: column;
}
::ng-deep .media-upload-confirm-modal .modal-body {
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}
::ng-deep .media-upload-confirm-modal .modal-footer {
  padding: 0.65rem 1rem;
  border-top: 1px solid #eef0f2;
  gap: 0.5rem;
  flex-shrink: 0;
}
::ng-deep .media-upload-confirm-modal .modal-header {
  flex-shrink: 0;
}
::ng-deep .media-upload-confirm-modal .media-confirm-head {
  padding: 0.65rem 1rem;
  border-bottom: 1px solid #eef0f2;
  align-items: center;
}
::ng-deep .media-upload-confirm-modal .media-confirm-head__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  line-height: 1.3;
  padding-right: 0.5rem;
}
::ng-deep .media-upload-confirm-modal .media-confirm-head__close {
  margin: 0;
  padding: 0.25rem;
  opacity: 0.55;
}
::ng-deep .media-upload-confirm-modal .media-confirm-head__close:hover {
  opacity: 1;
}
::ng-deep .media-upload-confirm-modal .media-confirm-body {
  padding: 1.1rem 1.25rem 1.15rem;
}
::ng-deep .media-upload-confirm-modal .media-confirm-preview {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fafbfc;
  overflow: hidden;
}
::ng-deep .media-upload-confirm-modal .media-confirm-preview__pdf-shell {
  width: 100%;
  height: min(68vh, 640px);
  min-height: 360px;
  background: #fff;
}
::ng-deep .media-upload-confirm-modal .media-confirm-preview__pdf {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
::ng-deep .media-upload-confirm-modal .media-confirm-foot {
  justify-content: flex-end;
  align-items: center;
  gap: 0.55rem;
}

::ng-deep .media-confirm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 36px;
  margin: 0;
  padding: 0.45rem 0.95rem;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}
::ng-deep .media-confirm-btn__icon {
  font-size: 12px;
  line-height: 1;
}
::ng-deep .media-confirm-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--undp-jtf-primary-color, #2563eb) 28%, transparent);
}
::ng-deep .media-confirm-btn--secondary {
  background: transparent;
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: var(--undp-jtf-btn-dark-color, #003d7a);
}
::ng-deep .media-confirm-btn--secondary:hover {
  background: transparent;
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: var(--undp-jtf-btn-dark-color, #003d7a);
  text-decoration: none;
  opacity: 0.85;
}
::ng-deep .media-confirm-btn--primary {
  background: var(--undp-jtf-btn-dark-color, #003d7a);
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: #fff;
}
::ng-deep .media-confirm-btn--primary:hover {
  background: var(--undp-jtf-btn-dark-color, #003d7a);
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: #fff;
  text-decoration: none;
  opacity: 0.92;
}
::ng-deep .media-confirm-btn--ghost {
  background: transparent;
  border-color: #d0d7de;
  color: #5c6b7a;
}
::ng-deep .media-confirm-btn--ghost:hover {
  background: transparent;
  border-color: #b8c2cc;
  color: #334155;
}
::ng-deep .media-confirm-btn--danger {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}
::ng-deep .media-confirm-btn--danger:hover {
  background: #b91c1c;
  border-color: #b91c1c;
  color: #fff;
  opacity: 1;
}
::ng-deep .media-confirm-btn--danger:focus {
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);
}

::ng-deep .analysis-remove-file-modal .modal-footer {
  justify-content: flex-end;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 1rem;
  border-top: 1px solid #eef0f2;
}
::ng-deep .analysis-remove-file-modal .modal-header {
  padding: 0.65rem 1rem;
  border-bottom: 1px solid #eef0f2;
}
::ng-deep .analysis-remove-file-modal .modal-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
}
::ng-deep .analysis-remove-file-modal .modal-body {
  padding: 1.1rem 1.25rem;
}
::ng-deep .analysis-remove-file-modal .modal-content {
  border-radius: 10px;
  border: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-detail/post-detail.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAEF;AAAE;EACE,gBAAA;EACA,gCAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AACJ;;AAGA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;AAGI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AADN;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mDAAA;AAHJ;AAKI;EACE,mBAAA;EACA,8CAAA;AAHN;AAMI;EACE,aAAA;EACA,6CAAA;AAJN;AAQE;EACE,SAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;AANJ;AASE;EACE,uBAAA;AAPJ;AASI;EACE,UAAA;AAPN;AAYI;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAVN;AAaI;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAcI;EACE,mBAAA;AAZN;AAeI;EACE,gBAAA;AAbN;AAeM;EACE,gBAAA;AAbR;AAiBI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAfN;AAkBI;EACE,eAAA;EACA,eAAA;AAhBN;AAmBI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,6DAAA;EACA,4BAAA;EACA,mBAAA;EACA,iFAAA;AAjBN;AAmBM;EACE,qBAAA;EACA,mBAAA;EACA,qDAAA;AAjBR;AAoBM;EAEE,eAAA;EACA,aAAA;EACA,oBAAA;AAnBR;AAsBM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AApBR;AAuBM;EACE,eAAA;EACA,cAAA;AArBR;AAwBM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtBR;AA0BI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,0DAAA;AAxBN;AA0BM;EACE,WAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAxBR;AA0BQ;EACE,mBAAA;EACA,qBAAA;AAxBV;AA0BU;EACE,cAAA;AAxBZ;AA6BM;EACE,aAAA;AA3BR;AA8BM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AA5BR;AA+BM;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AA7BR;AAgCM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AA9BR;AAiCM;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AA/BR;AAiCQ;EACE,cAAA;AA/BV;AAkCQ;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAhCV;AAmCQ;EACE,cAAA;EACA,gBAAA;AAjCV;AAqCM;EACE,eAAA;EACA,cAAA;AAnCR;AAsCM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AApCR;AAwCI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,uEAAA;AAtCN;AAwCM;EACE,mBAAA;EACA,cAAA;AAtCR;AAyCM;EACE,aAAA;EACA,6CAAA;AAvCR;AA0CM;EAEE,YAAA;EACA,mBAAA;EACA,oBAAA;AAzCR;AA4CM;EACE,cAAA;AA1CR;AA4CQ;EACE,mBAAA;EACA,cAAA;AA1CV;AA+CI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,uHAAA;AA7CN;AAgDM;EACE,mBAAA;EACA,cAAA;AA9CR;AAiDM;EACE,aAAA;EACA,6CAAA;AA/CR;AAkDM;EAEE,aAAA;EACA,mBAAA;EACA,oBAAA;AAjDR;AAoDM;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAlDR;AAoDQ;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAlDV;AAsDM;EACE,mDAAA;EACA,qDAAA;EACA,WAAA;EACA,4CAAA;AApDR;AAsDQ;EACE,mDAAA;EACA,qDAAA;EACA,WAAA;EACA,aAAA;AApDV;AAuDQ;EACE,iGAAA;AArDV;AA0DI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAxDN;;AA6DA;EACE,gBAAA;EACA,gBAAA;AA1DF;;AA6DA;EACE,sBAAA;EACA,gBAAA;EACA,cAAA;AA1DF;;AA6DA;EACE,iCAAA;AA1DF;AA4DE;EACE,aAAA;EACA,kBAAA;AA1DJ;AA4DI;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA1DN;AA6DI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AA3DN;;AAkEI;;EAEE,oBAAA;EACA,6BAAA;EACA,kCAAA;EACA,uBAAA;AA/DN;AAkEI;EACE,cAAA;AAhEN;;AAqEA,uDAAA;AACA;EACE,wBAAA;AAlEF;AAoEE;EACE,sCAAA;EACA,oBAAA;EACA,gCAAA;AAlEJ;AAqEE;EACE,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;AAnEJ;AAsEE;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AApEJ;AAuEE;EACE,qBAAA;EACA,6BAAA;EACA,WAAA;EACA,cAAA;AArEJ;AAwEE;EACE,cAAA;AAtEJ;AAyEE;EACE,qBAAA;EACA,gCAAA;EACA,mBAAA;AAvEJ;AAyEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAvEN;AA0EI;EACE,SAAA;EACA,gBAAA;EACA,aAAA;AAxEN;AA0EM;EACE,UAAA;AAxER;AA6EE;EACE,+BAAA;AA3EJ;AA8EE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA5EJ;AA8EI;EACE,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;AA5EN;AA+EI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AA7EN;AAiFE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AA/EJ;;AAmFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,uHAAA;AAhFF;AAmFE;EACE,eAAA;EACA,cAAA;AAjFJ;AAoFE;EACE,aAAA;EACA,iGAAA;AAlFJ;AAqFE;EACE,uBAAA;EACA,qDAAA;EACA,8CAAA;AAnFJ;AAqFI;EACE,uBAAA;EACA,qDAAA;EACA,8CAAA;EACA,qBAAA;EACA,aAAA;AAnFN;AAuFE;EACE,mDAAA;EACA,qDAAA;EACA,WAAA;AArFJ;AAuFI;EACE,mDAAA;EACA,qDAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;AArFN;AAyFE;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAvFJ;AAyFI;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAvFN;AA2FE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAzFJ;AA2FI;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;AAzFN;AA4FI;EACE,6CAAA;AA1FN;;AAgGE;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,6BAAA;AA7FJ;AAgGE;EACE,qBAAA;EACA,gCAAA;AA9FJ;AAiGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/FJ;AAkGE;EACE,uBAAA;AAhGJ;AAmGE;EACE,mBAAA;EACA,YAAA;EACA,0CAAA;AAjGJ","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\n\n.report-detail {\n  color: #1f2937;\n  background: #f1f5f9;\n  border-radius: 0;\n  overflow: hidden;\n  min-height: 100%;\n\n  &__toolbar {\n    background: #fff;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  &__stack {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n  }\n}\n\n.report-panel {\n  background: #fff;\n  border: 1px solid #e8edf3;\n  border-radius: 8px;\n  overflow: hidden;\n\n  &--updates:has(> eview-post-updates.post-updates-host--hidden) {\n    display: none;\n  }\n\n  &__head {\n    padding: 14px 20px 0;\n\n    &--editable {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      gap: 8px;\n    }\n  }\n\n  &__edit-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 30px;\n    height: 30px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: #64748b;\n    font-size: 12px;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease;\n\n    &:hover {\n      background: #eef2f7;\n      color: var(--undp-jtf-btn-dark-color, #003d7a);\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);\n    }\n  }\n\n  &__title {\n    margin: 0;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eef2f7;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #64748b;\n    flex: 1 1 auto;\n  }\n\n  &__body {\n    padding: 16px 20px 20px;\n\n    &--flush {\n      padding: 0;\n    }\n  }\n\n  &--analysis {\n    .report-analysis__input {\n      width: 100%;\n      min-height: 140px;\n      resize: vertical;\n      line-height: 1.55;\n    }\n\n    .report-analysis__readonly {\n      margin: 0 0 14px;\n      white-space: pre-wrap;\n      color: #1f2937;\n      font-size: 15px;\n      line-height: 1.65;\n      padding: 12px 14px;\n      background: #f8fafc;\n      border: 1px solid #eef2f7;\n      border-radius: 8px;\n      min-height: 80px;\n    }\n\n    .report-analysis__actions {\n      margin-bottom: 14px;\n    }\n\n    .report-analysis__file {\n      margin-top: 14px;\n\n      &--readonly {\n        margin-top: 12px;\n      }\n    }\n\n    .report-analysis__file-empty-text {\n      margin: 8px 0 0;\n      color: #94a3b8;\n      font-size: 13px;\n    }\n\n    .report-analysis__file-error {\n      margin: 8px 0 0;\n      font-size: 13px;\n    }\n\n    .analysis-file-dropzone {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      width: 100%;\n      min-height: 112px;\n      margin: 0;\n      padding: 18px 16px;\n      cursor: pointer;\n      text-align: center;\n      background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n      border: 1.5px dashed #cbd5e1;\n      border-radius: 10px;\n      transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n\n      &:hover:not(.analysis-file-dropzone--disabled) {\n        border-color: #64748b;\n        background: #f8fafc;\n        box-shadow: inset 0 0 0 1px rgba(100, 116, 139, 0.08);\n      }\n\n      &--disabled,\n      &--uploading {\n        cursor: default;\n        opacity: 0.85;\n        pointer-events: none;\n      }\n\n      &__badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 40px;\n        padding: 4px 8px;\n        border-radius: 6px;\n        background: #fee2e2;\n        color: #b91c1c;\n        font-size: 11px;\n        font-weight: 700;\n        letter-spacing: 0.06em;\n        line-height: 1;\n      }\n\n      &__title {\n        font-size: 14px;\n        color: #1e293b;\n      }\n\n      &__hint {\n        max-width: 280px;\n        font-size: 12px;\n        line-height: 1.4;\n        color: #94a3b8;\n      }\n    }\n\n    .analysis-file-card {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      width: 100%;\n      padding: 12px 14px;\n      background: #f8fafc;\n      border: 1px solid #e8edf3;\n      border-radius: 10px;\n      text-decoration: none;\n      color: inherit;\n      transition: border-color 0.15s ease, background 0.15s ease;\n\n      &--readonly {\n        width: 100%;\n        margin: 0;\n        cursor: pointer;\n        text-align: left;\n\n        &:hover {\n          background: #f1f5f9;\n          border-color: #dbe3ee;\n\n          .analysis-file-card__name {\n            color: #1d4ed8;\n          }\n        }\n      }\n\n      &--uploading {\n        opacity: 0.75;\n      }\n\n      &__main {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        min-width: 0;\n        flex: 1 1 200px;\n      }\n\n      &__badge {\n        flex-shrink: 0;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 40px;\n        padding: 6px 8px;\n        border-radius: 6px;\n        background: #fee2e2;\n        color: #b91c1c;\n        font-size: 11px;\n        font-weight: 700;\n        letter-spacing: 0.06em;\n        line-height: 1;\n      }\n\n      &__meta {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n        min-width: 0;\n      }\n\n      &__name {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        color: #0f172a;\n        font-size: 14px;\n        font-weight: 600;\n        text-decoration: none;\n        max-width: 100%;\n\n        &:hover {\n          color: #1d4ed8;\n        }\n\n        &--btn {\n          display: block;\n          width: 100%;\n          margin: 0;\n          padding: 0;\n          border: 0;\n          background: transparent;\n          text-align: left;\n          cursor: pointer;\n        }\n\n        &--pending {\n          color: #64748b;\n          font-weight: 500;\n        }\n      }\n\n      &__sub {\n        font-size: 12px;\n        color: #94a3b8;\n      }\n\n      &__actions {\n        display: flex;\n        align-items: center;\n        gap: 2px;\n        flex-shrink: 0;\n      }\n    }\n\n    .analysis-icon-btn {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 34px;\n      height: 34px;\n      margin: 0;\n      padding: 0;\n      border: 0;\n      border-radius: 7px;\n      background: transparent;\n      color: #64748b;\n      font-size: 13px;\n      line-height: 1;\n      cursor: pointer;\n      transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n\n      &:hover:not(:disabled):not(.is-disabled) {\n        background: #eef2f7;\n        color: #0f172a;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);\n      }\n\n      &:disabled,\n      &.is-disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        pointer-events: none;\n      }\n\n      &--danger {\n        color: #94a3b8;\n\n        &:hover:not(:disabled):not(.is-disabled) {\n          background: #fef2f2;\n          color: #b91c1c;\n        }\n      }\n    }\n\n    .analysis-btn {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      margin: 0;\n      padding: 8px 14px;\n      border: 1px solid transparent;\n      border-radius: 7px;\n      background: transparent;\n      color: #475569;\n      font-size: 13px;\n      font-weight: 600;\n      line-height: 1.2;\n      cursor: pointer;\n      text-decoration: none;\n      white-space: nowrap;\n      transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n        box-shadow 0.15s ease, opacity 0.15s ease;\n\n      &:hover:not(:disabled):not(.is-disabled) {\n        background: #f1f5f9;\n        color: #0f172a;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18);\n      }\n\n      &:disabled,\n      &.is-disabled {\n        opacity: 0.55;\n        cursor: not-allowed;\n        pointer-events: none;\n      }\n\n      &--ghost {\n        background: transparent;\n        border-color: #d0d7de;\n        color: #5c6b7a;\n\n        &:hover:not(:disabled):not(.is-disabled) {\n          background: transparent;\n          border-color: #b8c2cc;\n          color: #334155;\n        }\n      }\n\n      &--primary {\n        background: var(--undp-jtf-btn-dark-color, #003d7a);\n        border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n        color: #fff;\n        box-shadow: 0 1px 2px rgba(0, 61, 122, 0.16);\n\n        &:hover:not(:disabled):not(.is-disabled) {\n          background: var(--undp-jtf-btn-dark-color, #003d7a);\n          border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n          color: #fff;\n          opacity: 0.92;\n        }\n\n        &:focus {\n          box-shadow: 0 0 0 3px color-mix(in srgb, var(--undp-jtf-primary-color, #2563eb) 28%, transparent);\n        }\n      }\n    }\n\n    .report-analysis__actions {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      gap: 8px;\n      margin-top: 14px;\n    }\n  }\n}\n\n.active-card-item {\n  border-top: none;\n  box-shadow: none;\n}\n\n.word-wrap {\n  word-break: break-word;\n  line-height: 1.6;\n  color: #1f2937;\n}\n\n.custom-ui {\n  color: var(--undp-jtf-text-color);\n\n  .modal-body {\n    padding: 32px;\n    border-radius: 8px;\n\n    p {\n      font-size: 16px;\n      margin-bottom: 24px;\n      color: #374151;\n      line-height: 1.6;\n    }\n\n    .btn {\n      border-radius: 8px;\n      padding: 12px 28px;\n      font-weight: 600;\n    }\n  }\n}\n\n::ng-deep {\n  .report-detail {\n    .card-subtitle,\n    .flex-subtitle-wrapper {\n      margin: 0 !important;\n      padding: 16px 20px !important;\n      background: transparent !important;\n      border: none !important;\n    }\n\n    eview-post-map-view {\n      display: block;\n    }\n  }\n}\n\n/* Same shell as form-attribute media confirm preview */\n::ng-deep .media-upload-confirm-modal {\n  z-index: 1070 !important;\n\n  .modal-dialog {\n    max-width: min(100vw - 1.25rem, 780px);\n    margin: 0.75rem auto;\n    max-height: calc(100vh - 1.5rem);\n  }\n\n  .modal-content {\n    border-radius: 10px;\n    border: none;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n    max-height: calc(100vh - 1.5rem);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-body {\n    padding: 0;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n  }\n\n  .modal-footer {\n    padding: 0.65rem 1rem;\n    border-top: 1px solid #eef0f2;\n    gap: 0.5rem;\n    flex-shrink: 0;\n  }\n\n  .modal-header {\n    flex-shrink: 0;\n  }\n\n  .media-confirm-head {\n    padding: 0.65rem 1rem;\n    border-bottom: 1px solid #eef0f2;\n    align-items: center;\n\n    &__title {\n      margin: 0;\n      font-size: 1rem;\n      font-weight: 600;\n      color: #212529;\n      line-height: 1.3;\n      padding-right: 0.5rem;\n    }\n\n    &__close {\n      margin: 0;\n      padding: 0.25rem;\n      opacity: 0.55;\n\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .media-confirm-body {\n    padding: 1.1rem 1.25rem 1.15rem;\n  }\n\n  .media-confirm-preview {\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    background: #fafbfc;\n    overflow: hidden;\n\n    &__pdf-shell {\n      width: 100%;\n      height: min(68vh, 640px);\n      min-height: 360px;\n      background: #fff;\n    }\n\n    &__pdf {\n      display: block;\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n  }\n\n  .media-confirm-foot {\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.55rem;\n  }\n}\n\n::ng-deep .media-confirm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 36px;\n  margin: 0;\n  padding: 0.45rem 0.95rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n    box-shadow 0.15s ease, opacity 0.15s ease;\n\n  &__icon {\n    font-size: 12px;\n    line-height: 1;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--undp-jtf-primary-color, #2563eb) 28%, transparent);\n  }\n\n  &--secondary {\n    background: transparent;\n    border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n    color: var(--undp-jtf-btn-dark-color, #003d7a);\n\n    &:hover {\n      background: transparent;\n      border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n      color: var(--undp-jtf-btn-dark-color, #003d7a);\n      text-decoration: none;\n      opacity: 0.85;\n    }\n  }\n\n  &--primary {\n    background: var(--undp-jtf-btn-dark-color, #003d7a);\n    border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n    color: #fff;\n\n    &:hover {\n      background: var(--undp-jtf-btn-dark-color, #003d7a);\n      border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n      color: #fff;\n      text-decoration: none;\n      opacity: 0.92;\n    }\n  }\n\n  &--ghost {\n    background: transparent;\n    border-color: #d0d7de;\n    color: #5c6b7a;\n\n    &:hover {\n      background: transparent;\n      border-color: #b8c2cc;\n      color: #334155;\n    }\n  }\n\n  &--danger {\n    background: #dc2626;\n    border-color: #dc2626;\n    color: #fff;\n\n    &:hover {\n      background: #b91c1c;\n      border-color: #b91c1c;\n      color: #fff;\n      opacity: 1;\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);\n    }\n  }\n}\n\n::ng-deep .analysis-remove-file-modal {\n  .modal-footer {\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.55rem;\n    padding: 0.65rem 1rem;\n    border-top: 1px solid #eef0f2;\n  }\n\n  .modal-header {\n    padding: 0.65rem 1rem;\n    border-bottom: 1px solid #eef0f2;\n  }\n\n  .modal-title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #212529;\n  }\n\n  .modal-body {\n    padding: 1.1rem 1.25rem;\n  }\n\n  .modal-content {\n    border-radius: 10px;\n    border: none;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
